import Vue from 'vue'
import App from './App.vue'
import router from './router'
//导入ElementUI文件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//导入自己的重置文件
import './assets/css/rester.css';
import VueCookies from 'vue-cookie'
Vue.use(VueCookies)
// VueCookies.prototype.cookie.config('2h')
import UrlEncode from './assets/js/UrlEncode.js' 

Vue.prototype.$UrlEncode = UrlEncode;

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
